import React from 'react';
import styled from 'styled-components';
import uploadIcon from '../images/upload-icon.svg';
import { ProductSpecs } from '../services/specs';
import SpecsRectangle from './SpecsRectangle';

const HoverableProductIcon = styled.div`
  transition: transform 250ms, filter 250ms;
  filter: drop-shadow(0px 2px 2px rgba(0, 0, 0, 0.1));

  &:hover {
    transform: translateY(-5px);
    filter: drop-shadow(0 5px 5px rgba(0, 0, 0, 0.1));
  }
`;

const UploadIconWrapper = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const UploadIcon = styled.img`
  width: 50px;
  height: 50px;
`;

export interface ProductIconProps {
  onClick: () => void;
  maxHeight: number;
  maxWidth: number;
  scaleFactor: number;
  specs: ProductSpecs;
}

export default function ProductIcon({
  maxHeight,
  maxWidth,
  scaleFactor,
  specs,
  onClick,
}: ProductIconProps) {
  return (
    <div
      style={{
        boxSizing: 'border-box',
        height: maxHeight,
        width: maxWidth,
        padding: 2, // make some room for the border
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-end',
      }}
    >
      <HoverableProductIcon style={{ cursor: 'pointer' }} onClick={onClick}>
        <SpecsRectangle
          labelComponent={
            <UploadIconWrapper>
              <UploadIcon src={uploadIcon} />
            </UploadIconWrapper>
          }
          scaleFactor={scaleFactor}
          boundaries={[
            {
              height: specs.bleedCentimeters.height,
              width: specs.bleedCentimeters.width,
              offsetX: specs.bleedCentimeters.anchorX,
              offsetY: specs.bleedCentimeters.anchorY,
              cornerRadius: specs.cornerRadiusCentimeters,
              backgroundStyle: 'white',
              borderColor: '#d9d9d9',
              borderStyle: 'solid',
              borderWidth: 1,
            },
            {
              height: specs.safeAreaCentimeters.height,
              width: specs.safeAreaCentimeters.width,
              offsetX: specs.safeAreaCentimeters.anchorX,
              offsetY: specs.safeAreaCentimeters.anchorY,
              cornerRadius: specs.cornerRadiusCentimeters,
              backgroundStyle: 'white',
              borderColor: '#c5cccf',
              borderStyle: 'dashed',
              borderWidth: 1,
            },
          ]}
        />
      </HoverableProductIcon>
    </div>
  );
}
